import * as React from 'react'
import PropTypes from 'prop-types'

const Checkbox = React.forwardRef(({ className, onCheckedChange, ...props }, ref) => {
  function handleChange(e) {
    if (onCheckedChange) {
      onCheckedChange(e.target.checked)
    }
  }

  return (
    <input
      type="checkbox"
      className={`h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${
        className || ''
      }`}
      ref={ref}
      onChange={handleChange}
      {...props}
    />
  )
})
Checkbox.displayName = 'Checkbox'

Checkbox.propTypes = {
  className: PropTypes.string,
  onCheckedChange: PropTypes.func
}

export { Checkbox }
